import React, { createContext, useContext, useEffect, useState } from 'react';
import { getBrandingOverrides } from './getBrandingOverrides';
import { defaults } from './defaultBranding';
import { merge } from 'lodash';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { applyUserOverrides } from './applyUserBranding';

export const BrandingContext = createContext({
  branding: { ...defaults },
});

// setup and get the branding provider
export const BrandingProvider = ({ children, tenantId }) => {
  const [branding, setBranding] = useState({
    ...defaults,
  });

  const [isBranded, setIsBranded] = useState(false);

  const user = useSelector(selectAuthenticatedUser);

  useEffect(() => {
    async function loadBranding() {
      if (!tenantId ) return;

      const brand = await getBrandingOverrides(tenantId);
      if (brand.length === 0) return;
      const role = user?.roles?.[0]?.role?.name;
      
      if(!role) return;

      const updatedBrand = applyUserOverrides(brand[0], role);

      setBranding(merge(branding, { ...updatedBrand }));
      setIsBranded(true);
    }

    loadBranding();
  }, [tenantId, user]);

  return (
    <BrandingContext.Provider value={{ branding, setBranding, isBranded }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = (context = BrandingContext) => {
  const brandingContext = useContext(context);

  if (brandingContext === undefined) {
    throw new Error('UseBranding must be used within Branding context');
  }

  return {
    branding: brandingContext.branding,
    isBranded: brandingContext.isBranded,
  };
};
